import { render, staticRenderFns } from "./SingleDragAndDrop.vue?vue&type=template&id=70d84891&scoped=true"
import script from "./SingleDragAndDrop.vue?vue&type=script&lang=js"
export * from "./SingleDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./SingleDragAndDrop.vue?vue&type=style&index=0&id=70d84891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d84891",
  null
  
)

export default component.exports